import { categories, mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20birds%20eye%20view%20of%20a%20perfectly%20curated%20minimalist%20wardrobe%20display%20with%20folded%20pastel%20and%20earth%20tone%20clothing%20pieces%20arranged%20in%20rainbow%20gradient%20on%20light%20oak%20floor%2C%20one%20coffee%20cup%20and%20open%20magazine%20nearby%2C%20bright%20skylight%20overhead%20natural%20lighting%2C%20organizational%20inspiration%20photography%2C%20calm%20and%20orderly%20composition&width=1600&height=900&seq=hero-v2-01&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty i finds"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/20"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-2xl">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wider uppercase mb-6">
            Kakobuy Spreadsheet 2026
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-6">
            Kakobuy Spreadsheet
            <br />
            <span className="text-primary-500 italic">największa baza</span> produktów i finds
          </h1>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
            Odkrywaj sprawdzone produkty, aktualne listy zakupowe i najlepsze Kakobuy finds w jednym miejscu. Przeglądaj setki kategorii i znajdź to, czego szukasz.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              kakobuy sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-800 text-sm font-semibold hover:border-foreground-800 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap gap-4 mt-8">
            <span className="flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-check-line text-primary-500"></i> Aktualizowane listy
            </span>
            <span className="flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-check-line text-primary-500"></i> Kategorie premium
            </span>
            <span className="flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-check-line text-primary-500"></i> Darmowy dostęp
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}